(function () {
    var $form = $('.contact.contact-post-hire form');

    if ($form.length === 0) return;

    // Form validation
    var options = {
        groupClass: 'has-error',
        groupSelector: '.form-group',
        errorPosClasses: ['.input-group', '.selectize-control'],
        helpSpanDisplay: 'help-block',
        delay: false,
        disableSubmitBtn: false,
    };

    var metrics = [
        ['input[name="name"]', 'presence', gmtrans('contact.post_hire.frontend_validation.name_required')],
        ['input[name="email"]', 'presence', gmtrans('contact.post_hire.frontend_validation.email_required')],
        ['select[name="location"]', 'presence', gmtrans('contact.post_hire.frontend_validation.location_required')],
        [
            'input[name="booking_reference"]',
            'presence',
            gmtrans('contact.post_hire.frontend_validation.booking_reference_required'),
        ],
        [
            'input[name="date_branch_contacted"]',
            dateBranchContactedValidator,
            gmtrans('contact.post_hire.frontend_validation.date_branch_contacted_required'),
        ],
        ['select[name="enquiry"]', 'presence', gmtrans('contact.post_hire.frontend_validation.enquiry_required')],
    ];

    $form.nod(metrics, options);

    function dateBranchContactedValidator(value) {
        var branchContacted = $('input[name="branch_contacted"]').prop('checked');

        if (branchContacted && !value) {
            return false;
        }

        return true;
    }
})();
